// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"79e3c391","331":"21e7ca65"}[chunkId] + ".chunk.js";
};